/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  Component,
  ViewChild,
  OnInit
}                                from '@angular/core';

import { Logger                } from '@/util/logger';
import { bytesToSize }           from '@/util/util';
import { MatSidenav }            from '@angular/material/sidenav';
import { BlobService }           from '@/services/blob.service';
import { UserService }           from '@/services/user.service';
import { first }                 from 'rxjs/operators';
import {IUserRow} from "@/screens/administration/i.user.row";

@Component({
  templateUrl: 'admin.page.component.html'
})

/**
 *
 * @class AdminPageComponent
 *
 * @brief general system administration page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2021
 *
 */
export class AdminPageComponent implements OnInit {

  @ViewChild('adminsidenav')
  public         nav: MatSidenav;

  /** the total number of open approvals */
  public pendingCount: number = 0;

  /** the total number of users */
  public userCount: number = 0;

  /** total number of blobs in the system */
  public totalFiles: number = 0;

  /** total size of all blobs */
  public totalBytes: string = '';
  public totalBytesNum: number = 0;

  /** raw disk size */
  public blobDiskSize: string = '';

  /** actual disk used */
  public blobDiskUsed: string = '';

  /** actual remaining disk */
  public blobDiskAvail: string = '';

  /** actual percent filled disk */
  public blobDiskPercent: number = 0;

  /** size of postgresql database on disk */
  public dbSize: string = '';

  /** size of postgresql database on disk */
  public strokeColor: string = 'red';

  /** standard constructor */
  constructor(
    private blobber: BlobService,
    private users:   UserService
  ) {

  }

  /** open or close the side nav panel */
  toggleSidebar() {

    this.nav.toggle();
  }

  /** on page setup, create the form validator */
  ngOnInit() {

    Logger.debug('[AdminPage] init...');

    /*
     * fetch the disk hogs report, so we can get the total number of users and how much space
     * they are eating.
     *
     */

    let ap: AdminPageComponent = this;

    ap.blobber.diskHogs()
      .pipe(first())
      .subscribe(
        report => {

          Logger.debug(`[AdminPage] disk hogs: `, report);

          report.forEach((item: any) => {

            ap.totalFiles    += parseInt(item.files);
            ap.totalBytesNum += parseInt(item.usage);
          })

          ap.totalBytes += bytesToSize(ap.totalBytesNum);


        },
       error => {

          Logger.error(`[AdminPage] could not fetch disk hogs report: `, error);

        });

    ap.blobber.dbSize()
      .pipe(first())
      .subscribe(
        bytes => {

          Logger.debug(`[AdminPage] db size: `, bytes);

          ap.dbSize += bytesToSize(parseInt(bytes));

        },
        error => {

          Logger.error(`[AdminPage] could not fetch db size: `, error);

        });

    ap.blobber.diskCapacity()
      .pipe(first())
      .subscribe(
        (cap: any) => {

          Logger.debug(`[AdminPage] disk capacity: `, cap);

          ap.blobDiskSize = bytesToSize(parseInt(cap.size));
          ap.blobDiskUsed = bytesToSize(parseInt(cap.used));
          ap.blobDiskAvail= bytesToSize(parseInt(cap.avail));

          ap.blobDiskPercent = parseFloat((parseFloat(cap.used) / parseFloat(cap.size)).toFixed(2));

        },
        error => {

          Logger.error(`[AdminPage] could not fetch disk capacity: `, error);

        });

    ap.pendingCount = 0;
    ap.userCount    = 0;

    ap.users.dump()
      .pipe(first())
      .subscribe(
        (rows: IUserRow[]) => {

          rows.forEach((item: IUserRow) => {

            if(item.is_pending) {

              ap.pendingCount++;
            }

            ap.userCount++;

          });
        },
      error => {

          Logger.error(`[AdminPage] could not fetch user list: `, error);

        });

  }

}
